import { AxiosResponse } from "axios"

import { request } from "../../request"
import { CustomerData } from "../booking/hook"
import { DealershipData } from "./hook"

export type VehicleData = {
  Registration: string
  Mileage: number
  Condition: number
  HpiBasicLookup: object
}

const leadWithValuationConfig = {
  ActionType: "Valuation",
  VehicleType: "Car",
  Vehicle: {},
  Customer: {},
}

const mapCondition = (condition: number): string => {
  switch (condition) {
    case 1:
      return "Excellent"
    case 2:
      return "Good"
    case 3:
      return "Average"
    case 4:
      return "Below Average"
    default:
      return ""
  }
}

export const getLeadWithValuationRequest = async (
  leadRequestData: any,
  customerDetails: CustomerData,
  vehicle: VehicleData,
  dealership: DealershipData
): Promise<AxiosResponse<string>> => {
  const { DealershipName, DealershipGuid } = dealership

  const vehicleDetails = {
    Registration: vehicle?.Registration,
    Mileage: vehicle?.Mileage,
    Condition: mapCondition(vehicle?.Condition),
    HpiBasicLookup: vehicle?.HpiBasicLookup,
  }

  const vehicleDataWithValuation = { ...vehicleDetails, Valuation: leadRequestData }

  const data = {
    ...leadWithValuationConfig,
    Customer: customerDetails,
    Vehicle: vehicleDataWithValuation,
    DealershipName: DealershipName,
    DealershipGuid: DealershipGuid,
  }

  return request({
    url: "/CreateSalesLead",
    method: "post",
    headers: {
      "Access-Control-Request-Methods": "*",
      "Access-Control-Allow-Origin": "*",
    },
    timeout: 120000,
    data,
  })
}
